import { SomaMark } from "./SomaMark";
import { siteCopy } from "./site";
import type { LinkColumn } from "./types";

/** The site footer. Columns belong to the caller; the tagline and the legal line do not. */
export function SiteFooter({ columns, homeHref = "#top" }: { columns: LinkColumn[]; homeHref?: string }) {
  const t = siteCopy;
  return (
    <footer className="border-t border-line pt-10 pb-16 text-[13px] text-fg-muted">
      <div className="wrap flex flex-wrap justify-between gap-6">
        <div className="grid max-w-80 gap-2.5">
          <a href={homeHref} className="flex items-center gap-2.5 text-base font-medium text-fg">
            <SomaMark className="h-[18px] w-[19px] text-accent" />
            {t.brand}
          </a>
          <span>{t.footer.tagline}</span>
          <span className="font-mono text-[11px]">{t.footer.legal}</span>
        </div>
        <div className="flex flex-wrap gap-12">
          {columns.map((col) => (
            <div key={col.title} className="grid content-start gap-2">
              <span className="eyebrow mb-1 text-fg-faint">{col.title}</span>
              {col.links.map((l) => (
                <a key={l.label} href={l.href} className="transition-colors hover:text-fg">
                  {l.label}
                </a>
              ))}
            </div>
          ))}
        </div>
      </div>
    </footer>
  );
}
